<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" />

    <!--    아차사고 내용-->
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i>{{ $t('아차사고 내용') }}</h5>
      <div class="writeGridContainer">
        <div>
          <div>{{ $t('작업내용') }}</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_1 }}</p>
          <ml-input :readonly="board.readonly" v-else v-model="form.inputB_1" />
        </div>
        <div>
          <div>{{ $t('제안자') }}</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_2 }}</p>
          <ml-input :readonly="board.readonly" v-else v-model="form.inputB_2" />
        </div>
        <div>
          <div>{{ $t('재해형태') }}</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputB_3 }}</p>
          <disaster-class-selector v-else :readonly="board.readonly" v-model="form.inputB_3" />
        </div>
        <div>
          <div>{{ $t('발생일시') }}</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputB_4 }}</p>
          <date-selector v-else :readonly="board.readonly" v-model="form.inputB_4" />
        </div>
        <div>
          <div>{{ $t('발생장소') }}</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_5 }}</p>
          <ml-input :readonly="board.readonly" v-else v-model="form.inputB_5" />
        </div>

        <div class="writeGridLineItem">
          <div>{{ $t('발생개요') }}</div>
          <p v-if="isPrint" class="print-textarea flex-1">{{ form.inputB_6 }}</p>
          <ml-textarea :readonly="board.readonly" v-else v-model="form.inputB_6" rows="4" />
        </div>
        <div class="writeGridLineItem">
          <div>{{ $t('발생원인') }}</div>
          <p v-if="isPrint" class="print-textarea flex-1">{{ form.inputB_7 }}</p>
          <ml-textarea :readonly="board.readonly" v-else v-model="form.inputB_7" rows="4" />
        </div>
        <div class="writeGridLineItem">
          <div>{{ $t('예상피해') }}</div>
          <p v-if="isPrint" class="print-textarea flex-1">{{ form.inputB_8 }}</p>
          <ml-textarea :readonly="board.readonly" v-else v-model="form.inputB_8" rows="4" />
        </div>
        <div class="writeGridLineItem">
          <div>{{ $t('방지대책') }}</div>
          <p v-if="isPrint" class="print-textarea flex-1">{{ form.inputB_9 }}</p>
          <ml-textarea :readonly="board.readonly" v-else v-model="form.inputB_9" rows="4" />
        </div>
      </div>
    </div>

    <!--    사진대지-->
    <div class="xl:grid" style="grid-template-columns: 1fr 15px 1fr">
      <photo-upload-grid-module :row-count="1" :grid-count="1" v-model="form.photoList_1" :is-print="isPrint" :readonly="board.readonly" section-title="조치 전 사진" placeholder="개선 전 사진" />
      <div></div>
      <photo-upload-grid-module :row-count="1" :grid-count="1" v-model="form.photoList_2" :is-print="isPrint" :readonly="board.readonly" section-title="조치 후 사진" placeholder="개선 후 사진" />
    </div>

    <!--    위험성평가 반영 기준-->
<!--    <div class="mt-component-form">-->
<!--      <vs-row class="my-4">-->
<!--        <vs-col-->
<!--          ><h5><i class="dot"></i>{{ $t('위험성평가 반영 기준') }}</h5></vs-col-->
<!--        >-->
<!--      </vs-row>-->
<!--      <div class="grid grid-cols-12">-->
<!--        <div class="col-span-6 selects-content">-->
<!--          <div class="selects-content__title">{{ $t('개선 전 위험성 (5x4)') }}</div>-->
<!--          <div class="grid grid-cols-3 h-content">-->
<!--            <div class="selects-content__item">-->
<!--              <div class="item&#45;&#45;title">{{ $t('가능성(빈도)') }}</div>-->
<!--              <div class="item&#45;&#45;body">-->
<!--                <p v-if="isPrint" class="w-full flex-1">{{ form.inputD_1 }}</p>-->
<!--                <vs-select v-else v-model="form.inputD_1" autocomplete class="w-full" @change="handleChangeinputD_3">-->
<!--                  <vs-select-item :key="index" :value="item.value" :text="item.label" v-for="(item, index) in options1" />-->
<!--                </vs-select>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="selects-content__item">-->
<!--              <div class="item&#45;&#45;title">{{ $t('중대성(강도)') }}</div>-->
<!--              <div class="item&#45;&#45;body">-->
<!--                <p v-if="isPrint" class="w-full flex-1">{{ form.inputD_2 }}</p>-->
<!--                <vs-select v-else v-model="form.inputD_2" autocomplete class="w-full" @change="handleChangeinputD_3">-->
<!--                  <vs-select-item :key="index" :value="item.value" :text="item.label" v-for="(item, index) in options2" />-->
<!--                </vs-select>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="selects-content__item">-->
<!--              <div class="item&#45;&#45;title">{{ $t('위험성') }}</div>-->
<!--              <div class="item&#45;&#45;body">-->
<!--                <p v-if="isPrint" class="w-full flex-1">{{ form.inputD_3 }}</p>-->
<!--                <ml-input :readonly="true" v-else v-model="form.inputD_3" class="flex-1 text-select-item" :class="form.inputD_3" :style="{ color: inputD_3_color }" />-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="col-span-6 selects-content">-->
<!--          <div class="selects-content__title">{{ $t('개선 후 위험성 (5x4)') }}</div>-->
<!--          <div class="grid grid-cols-3 h-content">-->
<!--            <div class="selects-content__item">-->
<!--              <div class="item&#45;&#45;title">{{ $t('가능성(빈도)') }}</div>-->
<!--              <div class="item&#45;&#45;body">-->
<!--                <p v-if="isPrint" class="w-full flex-1">{{ form.inputD_4 }}</p>-->
<!--                <vs-select v-else v-model="form.inputD_4" autocomplete class="w-full" @change="handleChangeinputD_6">-->
<!--                  <vs-select-item :key="index" :value="item.value" :text="item.label" v-for="(item, index) in options1" />-->
<!--                </vs-select>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="selects-content__item">-->
<!--              <div class="item&#45;&#45;title">{{ $t('중대성(강도)') }}</div>-->
<!--              <div class="item&#45;&#45;body">-->
<!--                <p v-if="isPrint" class="w-full flex-1">{{ form.inputD_5 }}</p>-->
<!--                <vs-select v-else v-model="form.inputD_5" autocomplete class="w-full" @change="handleChangeinputD_6">-->
<!--                  <vs-select-item :key="index" :value="item.value" :text="item.label" v-for="(item, index) in options2" />-->
<!--                </vs-select>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="selects-content__item">-->
<!--              <div class="item&#45;&#45;title">{{ $t('위험성') }}</div>-->
<!--              <div class="item&#45;&#45;body">-->
<!--                <p v-if="isPrint" class="w-full flex-1">{{ form.inputD_6 }}</p>-->
<!--                <ml-input :readonly="true" v-else v-model="form.inputD_6" class="flex-1 text-select-item" :class="form.inputD_6" :style="{ color: inputD_6_color }" />-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->

<!--    <div class="flex justify-between items-center mt-4 mb-6">-->
<!--      <p>{{ $t('제안등급') }}</p>-->

<!--      <vs-checkbox v-for="ratings in ['매우높음(16~20)', '높음(15)', '약간높음(9~12)', '보통(8)', '낮음(4~6)', '매우낮음(1~3)']" :key="`rating_${ratings}`" :vs-value="ratings" :value="ratings === form.inputD_7" @change="onChangeRatings">-->
<!--        {{ ratings }}-->
<!--      </vs-checkbox>-->
<!--    </div>-->

    <!-- 파일첨부 -->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import DisasterClassSelector from "@/components/selector/DisasterClassSelector.vue";
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import DateSelector from "@/components/selector/DateSelector.vue";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule.vue";

export default {
  components: {
    PhotoUploadGridModule,
    DateSelector,
    DisasterClassSelector,
    FieldSelectModule,
    FileUploadModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        fileList: [],
        photoList_1: [],
        photoList_2: [],

        inputB_1: "",
        inputB_2: "",
        inputB_3: "",
        inputB_4: "",
        inputB_5: "",
        inputB_6: "",
        inputB_7: "",
        inputB_8: "",
        inputB_9: "",

        inputD_1: "",
        inputD_2: "",
        inputD_3: "",
        inputD_4: "",
        inputD_5: "",
        inputD_6: "",
        inputD_7: "",
      },
      options1: [
        { value: 1, label: "1" },
        { value: 2, label: "2" },
        { value: 3, label: "3" },
        { value: 4, label: "4" },
        { value: 5, label: "5" },
      ],
      options2: [
        { value: 1, label: "1" },
        { value: 2, label: "2" },
        { value: 3, label: "3" },
        { value: 4, label: "4" },
      ],
      inputD_3_color: "",
      inputD_6_color: "",
    };
  },
  methods: {
    handleResult(result) {
      if (result <= 3) return "매우낮음";
      else if (result <= 6) return "낮음";
      else if (result === 8) return "보통";
      else if (result <= 12) return "약간높음";
      else if (result === 15) return "높음";
      else if (result <= 20) return "매우높음";
    },
    checkColor(value) {
      if (value >= 1 && value <= 3) {
        return "#28C76F";
      } else if (value >= 4 && value <= 6) {
        return "#FF8510";
      } else {
        return "#E42728";
      }
    },
    handleChangeinputD_3() {
      let multiplication = this.form.inputD_1 * this.form.inputD_2;
      this.form.inputD_3 = this.handleResult(multiplication);
      this.inputD_3_color = this.checkColor(multiplication);
    },
    handleChangeinputD_6() {
      let multiplication = this.form.inputD_4 * this.form.inputD_5;
      this.form.inputD_6 = this.handleResult(multiplication);
      this.inputD_6_color = this.checkColor(multiplication);
    },
    onChangeRatings(data) {
      this.form.inputD_7 = data;
    },
  },
};
</script>

<style scoped lang="scss">
.title {
  font-weight: 500;
  font-size: 16px;
  height: 17px;
  line-height: 17px;
  position: relative;
}

.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}

.input-se {
  width: 100%;

  &::v-deep .start-end-title {
    width: 114px;
    font-weight: 500;
    font-size: 14px;
    justify-content: flex-start;
  }

  &::v-deep .mr-2 {
    flex: 1;
    margin-right: 20px !important;
  }

  &::v-deep .mr-2 + .mr-2 {
    margin-right: 0 !important;
    position: relative;

    &::before {
      content: "~";
      width: 10px;
      position: absolute;
      left: -15px;
      text-align: center;
    }
  }

  &::v-deep .inline-block {
    width: 100% !important;
  }
}

$border: 1px solid #cdcdcd;

.form-group {
  border-top: $border;
  border-bottom: $border;
  overflow: auto;
  width: 100%;

  &__header {
    background: #f9f9f9;
    height: 52px;
    width: 100%;
    display: flex;

    &-title {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    &-title.title-checked {
      margin: 0 auto;
      border: none;
    }
  }

  &__content {
    width: 100%;
    display: flex;

    &-row {
      padding: 7px;
      border-bottom: $border;
    }

    &-row.row-checked {
      margin: 0;
      border-left: none;
      padding-left: 10px;
    }
  }
}
.selects-content {
  border: $border;
  &:last-child {
    border-left: none;
  }
  &__title {
    height: 54px;
    line-height: 54px;
    text-align: center;
    background: #fafafa;
    border-bottom: $border;
  }
  &__item {
    border-left: $border;
    &:first-child {
      border-left: none;
    }
    .item--title {
      height: 54px;
      line-height: 54px;
      text-align: center;
      background: #fafafa;
      border-bottom: $border;
    }
    .item--body {
      padding: 7px;
      height: calc(100% - 54px);
      display: flex;
      justify-content: center;
      .input-area {
        border: 1px solid #cdcdcd;
        border-radius: 5px;
        margin: 0;
      }
      .input-area-text {
        margin: 0;
        height: 85px;
        width: 100%;
        padding: 5px;
      }
    }
  }
  .h-content {
    height: calc(100% - 54px);
  }
}
</style>
